// designationService.js
import apiInstance from 'services/ApiService';
import { ApiConfig } from 'config/ApiConfig';
import { CRUD_ENTITIES } from '../utils/entitiesCrud';
import { appendToastStatus } from 'utils/utils';
import { STATE_ENTITIES } from 'utils/entities';


export const createState = async (data) => {
  const { url, method ,toastStatus } = ApiConfig.STATE.CREATE;
  const requestData = appendToastStatus(data, toastStatus);
  const response = await apiInstance({ url, method, data :requestData });
  return { response, entity: CRUD_ENTITIES.STATE.namespace };
};

export const updateState = async (data , {id}) => {
  const { url, method ,toastStatus } = ApiConfig.STATE.UPDATE;
  const updateUrl = url.replace(':id',id); // Use id in URL
  const requestData = appendToastStatus(data, toastStatus);
  const response = await apiInstance({
    url: updateUrl, 
    method,
    data: requestData
  });
  return { response, entity: CRUD_ENTITIES.STATE.namespace};
};


export const deleteState = async (id) => {
  const { url, method, toastStatus } = ApiConfig.STATE.DELETE;
  const deleteUrl = url.replace(':id', id); // Use id in URL
  const requestData = appendToastStatus({}, toastStatus);
  const response = await apiInstance({
    url: deleteUrl, 
    method,
    data: requestData
  });
  
  return { response, entity: CRUD_ENTITIES.STATE.namespace };
};

export const readState = async (params) => {
  const { url, method } = ApiConfig.STATE.READ;
  const response = await apiInstance({ url, method,params });
  return { response, entity: CRUD_ENTITIES.STATE.namespace };
};


/**
 * Service to read one state.
 * 
 * @param {Object} data - The data for reading a single state
 * @returns {Promise} - The API response and entity information
 */
export const readOneState = async (id) => {
  const { url, method ,toastStatus } = ApiConfig.STATE.READ_ONE;
  const getUrl = url.replace(':id', id); // Use id in URL
  const requestData = appendToastStatus({}, toastStatus);
  const response = await apiInstance({
    url :getUrl, 
    method, 
    data : requestData
  });
  
  return { response, entity: CRUD_ENTITIES.STATE.namespace };
};



export const updateStateStatus = async (data , {id}) => {
  const { url, method ,toastStatus ,loading } = ApiConfig.STATE.CHANGE_STATUS;
  const updateUrl = url.replace(':id',id); // Use id in URL
  const requestData = appendToastStatus(data, toastStatus);
  const response = await apiInstance({
    url: updateUrl, 
    method,
    data: requestData
  });
  return { response, entity: CRUD_ENTITIES.STATE.namespace ,loading};
};


export const readStateCityService = async (params) => {
  const { url, method } = ApiConfig.GLOBAL.STATE_CITY;
  const response = await apiInstance({ url, method ,params });
  return { response, entity: STATE_ENTITIES.GLOBAL.STATE_CITY };
};



export const readHomePageService = async (params) => {
  const { url, method,toastStatus ,apiLoading} = ApiConfig.GLOBAL.HOMEPAGE;
  const requestData = appendToastStatus({}, toastStatus ,apiLoading);
  const response = await apiInstance({ url, method ,params ,data:requestData });
  return { response, entity: STATE_ENTITIES.GLOBAL.HOMEPAGE };
};


export const getAdvertisementService = async (params) => {
  const { url, method } = ApiConfig.GLOBAL.ADVERT;
  const response = await apiInstance({ url, method ,params });
  return { response, entity: STATE_ENTITIES.GLOBAL.ADVERT };
};